export class DashboardlineRQ {
  public dtInicio: string;
  public dtFim: string;
}
